import { throttle } from 'lodash';

export function scrollAction() {
  window.addEventListener(
    'scroll',
    _.throttle(
      e => {
        // ここに処理
        if($('.p-top').hasClass('is-animated')) {
          $('.p-scroll_btn').addClass('is-view');
        } else {
          $('.p-scroll_btn').removeClass('is-view');
        }
        return false;
      },
      50,
      { trailing: true, leading: true }
    )
  );
}